const isMobile = window.matchMedia('(max-width: 768px)');

if (isMobile.matches) {
    document.querySelectorAll('.page__content table').forEach((table) => {
        const wrapper = document.createElement('div');
        wrapper.className = 'scrollable-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
}

function myFunction1() {
    let moreText = document.getElementById("more1");
    let btnText = document.getElementById("myBtn1");

    // Check if required elements exist
    if (!moreText || !btnText) {
        console.error("Required elements not found for myFunction1");
        return;
    }

    // Toggle the display of more content
    if (moreText.style.display === "none" || moreText.style.display === "") {
        moreText.style.display = "block";
        btnText.innerHTML = "Read less";
    } else {
        moreText.style.display = "none";
        btnText.innerHTML = "Read more";
    }
}

function myFunction2() {
    let dots = document.getElementById("dots2");
    let moreText = document.getElementById("more2");
    let btnText = document.getElementById("myBtn2");

    if (dots.style.display === "none") {
        dots.style.display = "inline";
        btnText.innerHTML = "Read more";
        moreText.style.display = "none";
    } else {
        dots.style.display = "none";
        btnText.innerHTML = "Read less";
        moreText.style.display = "inline";
    }
}

function myFunction3() {
    let dots = document.getElementById("dots3");
    let moreText = document.getElementById("more3");
    let btnText = document.getElementById("myBtn3");

    if (dots.style.display === "none") {
        dots.style.display = "inline";
        btnText.innerHTML = "Read more";
        moreText.style.display = "none";
    } else {
        dots.style.display = "none";
        btnText.innerHTML = "Read less";
        moreText.style.display = "inline";
    }
}

function myFunction4() {
    let dots = document.getElementById("dots4");
    let moreText = document.getElementById("more4");
    let btnText = document.getElementById("myBtn4");

    if (dots.style.display === "none") {
        dots.style.display = "inline";
        btnText.innerHTML = "Read more";
        moreText.style.display = "none";
    } else {
        dots.style.display = "none";
        btnText.innerHTML = "Read less";
        moreText.style.display = "inline";
    }
}

function myFunction5() {
    let dots = document.getElementById("dots5");
    let moreText = document.getElementById("more5");
    let btnText = document.getElementById("myBtn5");

    if (dots.style.display === "none") {
        dots.style.display = "inline";
        btnText.innerHTML = "Read more";
        moreText.style.display = "none";
    } else {
        dots.style.display = "none";
        btnText.innerHTML = "Read less";
        moreText.style.display = "inline";
    }
}

function myFunction6() {
    let dots = document.getElementById("dots6");
    let moreText = document.getElementById("more6");
    let btnText = document.getElementById("myBtn6");

    if (dots.style.display === "none") {
        dots.style.display = "inline";
        btnText.innerHTML = "Read more";
        moreText.style.display = "none";
    } else {
        dots.style.display = "none";
        btnText.innerHTML = "Read less";
        moreText.style.display = "inline";
    }
}

function myFunction7() {
    let dots = document.getElementById("dots7");
    let moreText = document.getElementById("more7");
    let btnText = document.getElementById("myBtn7");

    if (dots.style.display === "none") {
        dots.style.display = "inline";
        btnText.innerHTML = "Read more";
        moreText.style.display = "none";
    } else {
        dots.style.display = "none";
        btnText.innerHTML = "Read less";
        moreText.style.display = "inline";
    }
}